import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
import { getStorageData } from "framework/src/Utilities";
import { InfoType } from "../../../components/src/CustomInfoDialog.web"

interface IToggle2faPayload {
  two_factor_enabled: boolean
}

interface INotificationPayload {
  chat_notification: boolean
  in_app_notification: boolean
}

interface IToggle2faSuccessResponse {
  message: string
  success: boolean
  two_factor_enabled: boolean
}

interface ISettingsDetailsSuccessResponse {
  data: {
    id: string
    type: string
    attributes: {
      id: number
      title: string | null
      name: string | null
      account_id: number
      two_factor_enabled: boolean
      email_notification: boolean
      chat_notification:boolean
      in_app_notification: boolean
      desktop_notification: boolean
      first_name: string
      last_name: string
      email: string
      full_phone_number: string
      roles: string
    }
  }
}

interface IUpdateDetailsSuccessResponse {
  data: {
    id: number,
    full_phone_number: number,
    country_code: number,
    phone_number: number,
    first_name: string,
    last_name: string,
    email: string,
    activated: boolean,
    device_id: null,
    unique_auth_id: string,
    password_digest: string,
    created_at: string,
    updated_at: string,
    user_name: null,
    platform: null,
    user_type: null,
    app_language_id: null,
    last_visit_at: null,
    is_blacklisted: boolean,
    suspend_until: null,
    status: string,
    full_name: null,
    role_id: null,
    gender: string,
    date_of_birth: null,
    age: number,
    terms_accepted: boolean,
    roles: string,
    is_mobile_verified: boolean,
    reset_password_token: null,
    reset_password_sent_at: null,
    reset_token_expires_at: null,
    description: string,
    languages: [],
    portfolio_links: [],
    height: 5.6,
    weight: 57,
    location: null,
    user_role: null,
    experience_level: null,
    blocked: boolean,
    locations: string,
    verification_token: null,
    social_media_links: {},
    is_email_verify: boolean,
    comet_chat_auth_token: string,
    comet_chat_uid: number,
    razorpay_customer_id: string
  }
}

interface IUpdateDetailsErrorResponse {
  success:boolean,
  message:string,
  errors: string[]
}
interface IUpdateEmailSuccessResponse {
  message:string,
  token:string,
  email:string
}

interface IUpdateErrorResponse {
  error:string
}

interface IGetOtpSuccessResponse {
  messgae:string
}

interface IGetOtpErrorResponse {
  error: string
}

interface IOtpVerificationErrorResponse {
  errors: {
    token: string
  }[]
}

interface IPhoneVerificationValues {
  phone_number: string
  pin: string
}

interface IPhoneVerificationSuccessResponse {
  message: string
}

interface IPhoneVerificationErrorResponse {
  error: string
}

// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  txtInputValue: string;
  txtSavedValue: string;
  enableField: boolean;
  // Customizable Area Start
  activeTab: string;
  isFirstNameModalOpen: boolean;
  isLastNameModalOpen: boolean;
  isEmailModalOpen: boolean;
  isMobileModalOpen: boolean;
  isRoleModalOpen: boolean;
  isOtpModalOpen: boolean;
  selectedContact: string;
  contactType: string;
  isResetPasswordModalOpen: boolean;
  isLoading: boolean
  is2FAEnabled: boolean
  isInfoDialog: boolean
  infoType: InfoType
  infoMessage: string
  chatEnabled:boolean;
  inAppEnabled: boolean;
  firstName: string,
  lastName: string,
  email: string,
  tempEmail:string,
  mobileNumber: string,
  role: string,
  password: string
  otpToken:string
  emailError:string
  otpError:string
  isSendingOtp: boolean
  isVerifyingPhone: boolean
  resetPasswordError:string
  tempMobileNumber:string
  userInfoError:string;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class Settings2Controller extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  updateAccountApiCallId : string = ""
  toggle2faApiCallId: string = ""
  settingsDetailsApiCallId: string = ""
  notificationsApiCallID: string = ""
  updateEmailApiCallId: string = ""
  otpVerificationApicall: string = ""
  sendPhoneOtpApiCallId: string = ""
  verifyPhoneOtpApiCallId: string = ""
  updatePasswordApicall: string = ""
  infoTimer: number = 0
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    // Customizable Area End

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage)
      // Customizable Area End
    ];

    this.state = {
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false,
      // Customizable Area Start
      activeTab: 'account',
      isFirstNameModalOpen: false,
      isLastNameModalOpen: false,
      isEmailModalOpen: false,
      isMobileModalOpen: false,
      isRoleModalOpen: false,
      isOtpModalOpen: false,
      selectedContact: '',
      contactType: '',
      isResetPasswordModalOpen: false,
      isLoading: false,
      is2FAEnabled: false,
      isInfoDialog: false,
      infoType: "error",
      infoMessage: "",
      chatEnabled: false,
      inAppEnabled: false,
      firstName:'',
      lastName:'',
      email:'',
      tempEmail:'',
      mobileNumber:'',
      role:'',
      password:'',
      otpToken:'',
      emailError:'',
      otpError:'',
      isSendingOtp: false,
      isVerifyingPhone: false,
      resetPasswordError:'',
      tempMobileNumber:'',
      userInfoError:'',
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async componentWillUnmount(): Promise<void> {
    if(this.infoTimer) {
      clearTimeout(this.infoTimer)
      this.infoTimer = 0
    }
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);

    if (message.id === getName(MessageEnum.AccoutLoginSuccess)) {
      let value = message.getData(getName(MessageEnum.AuthTokenDataMessage));

      this.showAlert(
        "Change Value",
        "From: " + this.state.txtSavedValue + " To: " + value
      );

      this.setState({ txtSavedValue: value });
    }

    // Customizable Area Start
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCalId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    if(apiRequestCalId === this.toggle2faApiCallId) {
      this.handleToggle2faApiResponse(responseJson)
    }else if(apiRequestCalId === this.settingsDetailsApiCallId) {
      this.handleSettingsDetailsApiResponse(responseJson)
    } else if (apiRequestCalId === this.notificationsApiCallID) {
      this.handleNotificationApiResponse(responseJson)
    } else if (apiRequestCalId === this.updateAccountApiCallId) {
      this.handleAccountDetailsApiResponse(responseJson)
    } else if (apiRequestCalId === this.updateEmailApiCallId) {
      this.handleupdateEmailApiResponse(responseJson)
    } else if (apiRequestCalId === this.otpVerificationApicall) {
      this.handleOtpVerificationResponse(responseJson)
    } else if (apiRequestCalId === this.updatePasswordApicall) {
      this.handleResetPasswordApiResponse(responseJson)
    } else if(apiRequestCalId === this.sendPhoneOtpApiCallId) {
      this.handleSendOtpResponse(responseJson)
    } else if( apiRequestCalId === this.verifyPhoneOtpApiCallId) {
      this.handleMobileOtpVerificationResponse(responseJson)
    }
    // Customizable Area End
  }

  txtInputWebProps = {
    onChangeText: (text: string) => {
      this.setState({ txtInputValue: text });
    },
    secureTextEntry: false,
  };

  txtInputMobileProps = {
    ...this.txtInputWebProps,
    autoCompleteType: "email",
    keyboardType: "email-address",
  };

  txtInputProps = this.isPlatformWeb()
    ? this.txtInputWebProps
    : this.txtInputMobileProps;

  btnShowHideProps = {
    onPress: () => {
      this.setState({ enableField: !this.state.enableField });
      this.txtInputProps.secureTextEntry = !this.state.enableField;
      this.btnShowHideImageProps.source = this.txtInputProps.secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  btnShowHideImageProps = {
    source: this.txtInputProps.secureTextEntry
      ? imgPasswordVisible
      : imgPasswordInVisible,
  };

  btnExampleProps = {
    onPress: () => this.doButtonPressed(),
  };

  doButtonPressed() {
    let message = new Message(getName(MessageEnum.AccoutLoginSuccess));
    message.addData(
      getName(MessageEnum.AuthTokenDataMessage),
      this.state.txtInputValue
    );
    this.send(message);
  }

  // web events
  setInputValue = (text: string) => {
    this.setState({ txtInputValue: text });
  };

  setEnableField = () => {
    this.setState({ enableField: !this.state.enableField });
  };

  // Customizable Area Start
  async componentDidMount(): Promise<void> {
    this.getSettingsDetails()
  }

  handleOpenFirstNameModal = () => {
    this.setState({ isFirstNameModalOpen: true });
  };

  handleCloseFirstNameModal = () => {
    this.setState({ isFirstNameModalOpen: false });
  };

  handleOpenLastNameModal = () => {
    this.setState({ isLastNameModalOpen: true });
  };

  handleCloseLastNameModal = () => {
    this.setState({ isLastNameModalOpen: false });
  };

  handleOpenEmailModal = () => {
    this.setState({
      isEmailModalOpen: true,
    });
  };
  
  handleCloseEmailModal = () => {
    this.setState({ isEmailModalOpen: false, emailError: "" });
  };

  handleOpenOtpModal = () => {
    this.setState({ isOtpModalOpen: true, isEmailModalOpen: false, isMobileModalOpen: false });
  };

  handleOpenMobileModal = () => {
    this.setState({
      isMobileModalOpen: true,
      selectedContact: "",
      contactType: "mobile",
    });
  };

  handleCloseMobileModal = () => {
    this.setState({ isMobileModalOpen: false, emailError: "" });
  };

  handleOpenRoleModal = () => {
    this.setState({ isRoleModalOpen: true });
  };

  handleCloseRoleModal = () => {
    this.setState({ isRoleModalOpen: false });
  };

  handleCloseOtpModal = () => {
    this.setState({ 
      isOtpModalOpen: false ,
      tempEmail: "",
      selectedContact: "",
      contactType: "",
      otpError: ""
    });
  };

  handleOpenResetPasswordModal = () => {
    this.setState({ isResetPasswordModalOpen: true });
  }

  handleCloseResetPasswordModal = () => {
    this.setState({ isResetPasswordModalOpen: false });
  }

  handleOpenInfoDialog = (infoType: InfoType, infoMessage: string = "") => {
    this.setState({ isInfoDialog: true, infoType, infoMessage })
  }

  handleCloseInfoDialog = () => {
    this.setState({ isInfoDialog: false })
    this.infoTimer = window.setTimeout(() => {
      this.setState({ infoType: "error", infoMessage: "" })
    }, 100)
  }

  handleToggle2fa = (_event: React.SyntheticEvent, checked: boolean) => {
    const payload = {
      two_factor_enabled: checked
    }
    this.setState({
      is2FAEnabled: checked,
      isLoading: true
    }, () => this.toggle2faApi(payload))
  }

  toggle2faApi = async (httpBody: IToggle2faPayload) => {
    const token = await getStorageData(configJSON.TOKEN)

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.toggle2faApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.toggle2faApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPatchMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleToggle2faApiResponse = (responseJson: IToggle2faSuccessResponse) => {
    if(responseJson.success) {
      this.setState({ isLoading: false })
    } else {
      this.setState((prevState) => ({
        isLoading: false,
        isInfoDialog: true,
        is2FAEnabled: !prevState.is2FAEnabled
      }))
    }
  }

  getSettingsDetails = async () => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN)

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.settingsDetailsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.settingsDetailsApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleSettingsDetailsApiResponse = (responseJson: ISettingsDetailsSuccessResponse) => {
    if("data" in responseJson) {
      const { data: {
        attributes: {
          two_factor_enabled,
          chat_notification,
          in_app_notification,
          first_name,
          last_name,
          email,
          full_phone_number,
          roles
        }
      }} = responseJson
      this.setState({
        is2FAEnabled: two_factor_enabled,
        chatEnabled:  chat_notification,
        inAppEnabled: in_app_notification,
        isLoading: false,
        firstName:first_name,
        lastName:last_name,
        email:email,
        mobileNumber:full_phone_number?.slice(2) || "",
        role:roles
      })
    }
  }

  handleNotifications = (type:'inApp' | 'chat') => (_event: React.SyntheticEvent, checked: boolean) => {
    const payload = {
      in_app_notification: type === 'inApp' ? checked : this.state.inAppEnabled,
      chat_notification: type === 'chat' ? checked : this.state.chatEnabled
    };
  
    this.setState({
      inAppEnabled: type === 'inApp' ? checked : this.state.inAppEnabled,
      chatEnabled: type === 'chat' ? checked : this.state.chatEnabled,
      isLoading: true
    }, () => this.notificationsApi(payload));
  };  

  notificationsApi = async (httpBody: INotificationPayload) => {
    const token = await getStorageData(configJSON.TOKEN)
    const header = { "Content-Type": configJSON.validationApiContentType, token };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.notificationsApiCallID = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.notificationApiEndpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPatchMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleNotificationApiResponse = (responseJson: IToggle2faSuccessResponse) => {
    if (responseJson.success) {
      this.setState({ isLoading: false })
    } else {
      this.setState((prevState) => ({
        isLoading: false,
        chatEnabled: !prevState.chatEnabled,
        inAppEnabled: !prevState.chatEnabled,
      }))
    }
  }

  handleValueUpdate = (updatedValue: string, fieldKey: "firstName" | "lastName" | "role" | "email" | "mobile") => {
    if (fieldKey === 'firstName') {
      this.setState({ firstName: updatedValue }, () => {
        this.accountDetailsApi();
      });
    } else if (fieldKey === 'lastName') {
      this.setState({ lastName: updatedValue }, () => {
        this.accountDetailsApi();
      });
    }  else if (fieldKey === 'role') {
      this.setState({ role: updatedValue }, () => {
        this.accountDetailsApi();
      });
    }  
  };  

  accountDetailsApi = async () => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN)
    const header = { "Content-Type": configJSON.validationApiContentType, token };
    const body = {
      first_name:this.state.firstName,
      last_name:this.state.lastName,
      role:this.state.role
    }
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.updateAccountApiCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.updateAccountApiEndpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(body));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPatchMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleAccountDetailsApiResponse = ( responseJson: IUpdateDetailsSuccessResponse | IUpdateDetailsErrorResponse ) => {
    if ('errors' in responseJson && Array.isArray(responseJson.errors)) {
      const errorMsg = responseJson.errors[0];
      this.setState({
        isLoading: false,
        userInfoError: errorMsg,
      });
      this.handleOpenInfoDialog("error", errorMsg || "")
    } else {
      this.setState({
        isLoading: false,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        role: this.state.role,
        isFirstNameModalOpen: false,
        isLastNameModalOpen: false,
        isRoleModalOpen: false,
        userInfoError: ''
      });
    }
  };

  handleResendOtp = () => {
    const { contactType, tempEmail, tempMobileNumber } = this.state;
    if (contactType === 'email') {
      this.handleEmailUpdate(tempEmail, 'email');
    } else if (contactType === 'mobile') {
      this.handleEmailUpdate(tempMobileNumber, 'mobile');
    }
  };  

  handleEmailUpdate = (value: string, fieldKey: "firstName" | "lastName" | "role" | "email" | "mobile") => {
    if (fieldKey === "email") {
      this.setState({
        tempEmail: value,
        selectedContact: value,
        contactType: "email",
        emailError: ""
      }, () => {
        this.updateEmailApi()
      });
    } else if (fieldKey === "mobile") {
      this.setState({
        tempMobileNumber: value,
        selectedContact: value,
        contactType: "mobile",
        emailError: ""
      }, () => {
        this.sendPhoneOtpApi()
      });
    }
  };

  updateEmailApi = async () => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN)
    const header = { "Content-Type": configJSON.validationApiContentType, token };
    const body = {
      email: this.state.tempEmail
    }
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.updateEmailApiCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.updateEmailApiEndpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(body));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPatchMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleupdateEmailApiResponse = (responseJson: IUpdateEmailSuccessResponse | IUpdateErrorResponse) => {
    if ('email' in responseJson) {
      this.setState({
        isLoading: false,
        isEmailModalOpen: false,
        isOtpModalOpen: true,
        otpToken: responseJson.token,
        emailError: ""
      });
    } else {
      this.setState({
        isLoading: false,
        isEmailModalOpen: true,
        isOtpModalOpen: false,
        emailError: (responseJson as IUpdateErrorResponse).error || "An unexpected error occurred."
      });
    }
  };

  handleVerifyOtp = (otp: string) => {
    const { contactType, tempMobileNumber } = this.state;
  
    if (contactType === 'email') {
      this.verifyEmailOtpApi(otp);
    } else if (contactType === 'mobile') {
      const payload: IPhoneVerificationValues = {
        phone_number: tempMobileNumber,
        pin: otp
      };
      this.submitPhoneOtpApi(payload);
    }
  };     

  verifyEmailOtpApi = async (otp: string) => {
    this.setState({ isLoading: true });
    const token = await getStorageData(configJSON.TOKEN)
    const header = { "Content-Type": configJSON.validationApiContentType, token };
    const endpoint = `${configJSON.otpVerificationEndpoint}?otp=${otp}`

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.otpVerificationApicall = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), endpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.exampleAPiMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleOtpVerificationResponse = (
    response: IGetOtpSuccessResponse | IOtpVerificationErrorResponse | IGetOtpErrorResponse
  ) => {
    let errorMessage = ""
    if ('errors' in response && response.errors.length > 0) {
      errorMessage = response.errors[0]?.token || "OTP verification failed."
    } else if ('error' in response) {
      errorMessage = response.error
    }

    if(errorMessage) {
      this.setState({
        isLoading: false,
        isOtpModalOpen: true,
        otpError: errorMessage,
        tempEmail: "",
      });
    } else {
      this.setState({
        isLoading: false,
        email: this.state.tempEmail,
        isOtpModalOpen: false,
        otpError: ''
      });
      this.handleOpenInfoDialog("success", "Email updated successfully")
    }
  };

  resetPasswordApi = async (newPassword: string, confirmPassword: string, currentPassword: string) => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN);
    const header = { "Content-Type": configJSON.validationApiContentType, token };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.updatePasswordApicall = requestMessage.messageId;
    const endpoint = `${configJSON.updatePasswordEndpoint}?new_password=${encodeURIComponent(newPassword)}&password_confirmation=${encodeURIComponent(confirmPassword)}&current_password=${encodeURIComponent(currentPassword)}`;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), endpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.exampleAPiMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }  
  
  handleResetPasswordApiResponse = (responseJson: IGetOtpSuccessResponse | IGetOtpErrorResponse) => {
    if ('error' in responseJson) {
      this.setState({
        isLoading: false,
        isResetPasswordModalOpen: true,
        resetPasswordError: responseJson.error
      });
    } else {
      this.setState({
        isLoading: false,
        isResetPasswordModalOpen: false,
        resetPasswordError: ''
      });
      this.handleOpenInfoDialog("success", "Password updated successfully")

    }
 }

 sendPhoneOtpApi = async () => {
  this.setState({ isLoading: true })
  const token = await getStorageData(configJSON.TOKEN);
  const endpoint = `${configJSON.sendPhonOtpApiEndPoint}?full_phone_number=${this.state.tempMobileNumber}`

  const header = { "Content-Type": configJSON.validationApiContentType, token};
  const requestMessage = new Message(  getName(MessageEnum.RestAPIRequestMessage) );
  this.sendPhoneOtpApiCallId = requestMessage.messageId;
  requestMessage.addData( getName(MessageEnum.RestAPIResponceEndPointMessage), endpoint);
  requestMessage.addData(  getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header) );
  requestMessage.addData( getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.exampleAPiMethod );
  runEngine.sendMessage(requestMessage.id, requestMessage);
  return true;
}

handleSendOtpResponse = (response: any) => {
  let errorMessage = ""
  if ('errors' in response && response.errors.length > 0) {
    errorMessage = response.errors[0]
  } else if ('error' in response) {
    errorMessage = response.error || "An unexpected error occurred."
  }

  if("message" in response) {
    this.setState({
      isLoading: false,
      isMobileModalOpen: false,
      isOtpModalOpen: true,
      emailError: ""
    });
  } else {
    this.setState({
      isLoading: false,
      isMobileModalOpen: true,
      isOtpModalOpen: false,
      emailError: errorMessage || "An unexpected error occurred."
    });
  }
};

submitPhoneOtpApi = async (payload: IPhoneVerificationValues) => {
  this.setState({ isLoading: true })
  const token = await getStorageData(configJSON.TOKEN)
  const endpoint = `${configJSON.verifyPhonOtpApiEndPoint}?otp=${payload.pin}`
  const header = {  "Content-Type": configJSON.validationApiContentType, token  };

  const requestMessage = new Message(  getName(MessageEnum.RestAPIRequestMessage) );
  this.verifyPhoneOtpApiCallId = requestMessage.messageId;
  requestMessage.addData(  getName(MessageEnum.RestAPIResponceEndPointMessage), endpoint );
  requestMessage.addData( getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header) );
  requestMessage.addData( getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPatchMethod );
  runEngine.sendMessage(requestMessage.id, requestMessage);
  return true;
}

handleMobileOtpVerificationResponse = (response: IPhoneVerificationSuccessResponse | IPhoneVerificationErrorResponse) => {
  if ('error' in response) {
    this.setState({
      isLoading: false,
      isVerifyingPhone: false,
      otpError: response.error || "OTP verification failed.",
    });
  } else {
    this.setState({
      isLoading: false,
      isVerifyingPhone: false,
      isOtpModalOpen: false,
      mobileNumber: this.state.tempMobileNumber,
      tempMobileNumber: "",
      otpError: "",
    });
    this.handleOpenInfoDialog("success", "Mobile number updated successfully")
  }
};
  // Customizable Area End
}
